var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 14.333c-2.672 4.278-6.984 7.26-12 7.26s-9.328-2.982-12-7.26c1.484-2.382 3.516-4.423 5.953-5.72A7.407 7.407 0 007 12.26c0 4.003 3.14 7.26 7 7.26s7-3.257 7-7.26c0-1.28-.328-2.544-.953-3.646 2.437 1.297 4.469 3.338 5.953 5.72zM14.75 8.111c0 .421-.344.778-.75.778-1.781 0-3.25 1.523-3.25 3.37 0 .422-.344.778-.75.778s-.75-.356-.75-.778c0-2.706 2.14-4.926 4.75-4.926.406 0 .75.357.75.778zM28 14.333c0-.405-.125-.777-.313-1.118C24.813 8.322 19.547 5 14 5 8.453 5 3.187 8.322.312 13.215c-.187.34-.312.713-.312 1.118 0 .405.125.778.313 1.118 2.874 4.894 8.14 8.216 13.687 8.216 5.547 0 10.813-3.306 13.688-8.216.187-.34.312-.713.312-1.118z"
  })));
}

export default SvgEye;